module.exports = __webpack_public_path__ + "img/Pakistan.a322af74.svg";